import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import CountyStateFIPS from '@app/models/county-state-fips';
import { Listing } from '@app/models';
import { ListingService } from '@app/services';


@Component({
    selector: 'create-listing-proxy',
    templateUrl: './create-listing-proxy.component.html',
    styleUrls: ['./create-listing-proxy.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateListingProxyComponent {

  listing = {} as Listing;
  private _selectedcountyStateLocation: CountyStateFIPS;

  public userIsLoggedIn: boolean;
  @Input()
  public acres: number = 0;
  public canCreateListing: boolean = false;

  constructor(public router: Router, readonly listingService: ListingService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle(`Outdoor Access - Create Listing Proxy`);

  }
  public onCreateListingClick() {
    
    const {  listing: { id, latitude, longitude } } = this;
    this.listing.acres = this.acres;
    this.listing.county = this._selectedcountyStateLocation.namelsad;
    this.listing.state = this._selectedcountyStateLocation.stateAbbr;
  
    if (latitude && longitude) {
      this.listingService.add(this.listing).subscribe(listing => {
          this.router.navigate(['/landowner/listing', listing.id]);
          // eslint-disable-next-line @typescript-eslint/naming-convention
          window.dataLayer.push({event: 'new_listing', new_listing_id: listing.id})
          });
        }
        return;
      }
}
